import { Box, Button, Typography } from '@mui/material';
import React from 'react';

import Modal from '@/components/Modal';
import { t } from '@/services/translations/config';
import { COLOR, ENTITY_COLOR } from '@/theme/colors';

import { Props } from './types';

const CancelAcceptedOrganisationInvitation: React.FC<Props> = ({
    name,
    onCancel,
}) => {
    return (
        <Modal isOpen center styles="pt-11 pb-7 px-9 min-w-[760px]">
            <Box className="flex flex-col">
                <Typography
                    fontSize={16}
                    fontWeight={700}
                    color={COLOR.ebonyClay}
                    className="mb-4"
                >
                    {t('Organisation:cancel_accepted_invitation_title')}
                </Typography>
                <Typography
                    fontSize={14}
                    fontWeight={300}
                    color={COLOR.ebonyClay}
                >
                    {t('Organisation:cancel_accepted_invitation_description', {
                        name,
                    })}
                </Typography>

                <Box className="flex gap-[4px] justify-end mt-4">
                    <Button
                        className="px-[20px] py-[10px] self-end"
                        variant="contained"
                        sx={{
                            fontSize: 12,
                            fontWeight: 700,
                            color: COLOR.white,
                            backgroundColor: ENTITY_COLOR.teams,
                            '&:hover': {
                                backgroundColor: ENTITY_COLOR.teams,
                            },
                        }}
                        onClick={onCancel}
                    >
                        <Typography
                            sx={{
                                fontSize: 12,
                                fontWeight: 700,
                                color: COLOR.white,
                            }}
                        >
                            {t('Actions:remove_from_list')}
                        </Typography>
                    </Button>
                </Box>
            </Box>
        </Modal>
    );
};

export default CancelAcceptedOrganisationInvitation;
